import { exists } from '../runtime.js';
import './ApiActivityType.js';
import './ApiAdditionalInfoType.js';
import './ApiAirportType.js';
import './ApiBaggageType.js';
import './ApiBaggageUnitType.js';
import './ApiBaseDataSource.js';
import './ApiBookingAction.js';
import './ApiBookingState.js';
import './ApiCabinClass.js';
import './ApiCamperFeatureType.js';
import './ApiClientType.js';
import './ApiComponentPriceType.js';
import './ApiComponentType.js';
import './ApiConfigurationDataType.js';
import './ApiDebitType.js';
import './ApiDirection.js';
import './ApiDistanceUnit.js';
import './ApiDocumentSubType.js';
import './ApiDocumentType.js';
import './ApiDurationType.js';
import { ApiFilterCategoryFromJSON, ApiFilterCategoryToJSON } from './ApiFilterCategory.js';
import './ApiFilterType.js';
import './ApiFuelType.js';
import './ApiGender.js';
import { ApiGetCamperDetailsRequestFromJSONTyped } from './ApiGetCamperDetailsRequest.js';
import { ApiGetCamperListRequestFromJSONTyped } from './ApiGetCamperListRequest.js';
import { ApiGetExtraServiceListRequestFromJSONTyped } from './ApiGetExtraServiceListRequest.js';
import { ApiGetExtraServiceRequestFromJSONTyped } from './ApiGetExtraServiceRequest.js';
import { ApiGetHotelDetailsRequestFromJSONTyped } from './ApiGetHotelDetailsRequest.js';
import { ApiGetHotelListRequestFromJSONTyped } from './ApiGetHotelListRequest.js';
import { ApiGetInsuranceDetailsRequestFromJSONTyped } from './ApiGetInsuranceDetailsRequest.js';
import { ApiGetInsuranceListRequestFromJSONTyped } from './ApiGetInsuranceListRequest.js';
import { ApiGetItemTripListRequestFromJSONTyped } from './ApiGetItemTripListRequest.js';
import { ApiGetItemTripRequestFromJSONTyped } from './ApiGetItemTripRequest.js';
import { ApiGetRelatedExtraServiceListRequestFromJSONTyped } from './ApiGetRelatedExtraServiceListRequest.js';
import { ApiGetRentalCarDetailsRequestFromJSONTyped } from './ApiGetRentalCarDetailsRequest.js';
import { ApiGetRentalCarListRequestFromJSONTyped } from './ApiGetRentalCarListRequest.js';
import { ApiGetTransferDetailsRequestFromJSONTyped } from './ApiGetTransferDetailsRequest.js';
import { ApiGetTransferListRequestFromJSONTyped } from './ApiGetTransferListRequest.js';
import './ApiImageType.js';
import './ApiInventory.js';
import './ApiItemType.js';
import './ApiNoteOriginType.js';
import './ApiNoteType.js';
import './ApiPackagePriceComponentType.js';
import './ApiPaymentDataType.js';
import './ApiPaymentOption.js';
import './ApiPaymentState.js';
import './ApiPriceModifierType.js';
import './ApiPriceType.js';
import './ApiRecommendationServiceType.js';
import './ApiRelatedServiceRelationType.js';
import './ApiRole.js';
import './ApiRowCharacteristics.js';
import './ApiSeatCharacteristics.js';
import './ApiServiceSelectionType.js';
import './ApiSortDirection.js';
import './ApiSortOption.js';
import './ApiSpecialRequestGroup.js';
import './ApiStaticContentType.js';
import './ApiTaxDisplay.js';
import './ApiTransmissionType.js';
import './ApiTravelStatusEnum.js';
import './ApiTravelerType.js';
import './ApiVoucherDeliveryType.js';
import './ApiWalletType.js';

/* tslint:disable */
function ApiServiceSearchCriteriaFromJSON(json) {
    return ApiServiceSearchCriteriaFromJSONTyped(json, false);
}
function ApiServiceSearchCriteriaFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'GetExtraServiceListRequest') {
            return ApiGetExtraServiceListRequestFromJSONTyped(json, true);
        }
        if (json['type'] === 'GetExtraServiceRequest') {
            return ApiGetExtraServiceRequestFromJSONTyped(json, true);
        }
        if (json['type'] === 'GetItemTripListRequest') {
            return ApiGetItemTripListRequestFromJSONTyped(json);
        }
        if (json['type'] === 'GetItemTripRequest') {
            return ApiGetItemTripRequestFromJSONTyped(json);
        }
        if (json['type'] === 'GetRentalCarListRequest') {
            return ApiGetRentalCarListRequestFromJSONTyped(json, true);
        }
        if (json['type'] === 'GetRentalCarDetailsRequest') {
            return ApiGetRentalCarDetailsRequestFromJSONTyped(json, true);
        }
        if (json['type'] === 'GetHotelListRequest') {
            return ApiGetHotelListRequestFromJSONTyped(json, true);
        }
        if (json['type'] === 'GetHotelDetailsRequest') {
            return ApiGetHotelDetailsRequestFromJSONTyped(json, true);
        }
        if (json['type'] === 'GetInsuranceDetailsRequest') {
            return ApiGetInsuranceDetailsRequestFromJSONTyped(json);
        }
        if (json['type'] === 'GetInsuranceListRequest') {
            return ApiGetInsuranceListRequestFromJSONTyped(json);
        }
        if (json['type'] === 'GetTransferListRequest') {
            return ApiGetTransferListRequestFromJSONTyped(json, true);
        }
        if (json['type'] === 'GetTransferDetailsRequest') {
            return ApiGetTransferDetailsRequestFromJSONTyped(json, true);
        }
        if (json['type'] === 'GetCamperListRequest') {
            return ApiGetCamperListRequestFromJSONTyped(json, true);
        }
        if (json['type'] === 'GetCamperDetailsRequest') {
            return ApiGetCamperDetailsRequestFromJSONTyped(json, true);
        }
        if (json['type'] === 'GetRelatedExtraServiceListRequest') {
            return ApiGetRelatedExtraServiceListRequestFromJSONTyped(json, true);
        }
    }
    return {
        'type': !exists(json, 'type') ? undefined : json['type'],
        'unitCodes': !exists(json, 'unitCodes') ? undefined : json['unitCodes'],
        'startDate': (json['startDate']),
        'endDate': (json['endDate']),
        'numberOfAdults': !exists(json, 'numberOfAdults') ? undefined : json['numberOfAdults'],
        'numberOfChildren': !exists(json, 'numberOfChildren') ? undefined : json['numberOfChildren'],
        'numberOfInfants': !exists(json, 'numberOfInfants') ? undefined : json['numberOfInfants'],
        'childAges': !exists(json, 'childAges') ? undefined : json['childAges'],
        'productName': !exists(json, 'productName') ? undefined : json['productName'],
        'productId': !exists(json, 'productId') ? undefined : json['productId'],
        'destinationGeoUnitId': !exists(json, 'destinationGeoUnitId') ? undefined : json['destinationGeoUnitId'],
        'requestFilterCategories': !exists(json, 'requestFilterCategories') ? undefined : (json['requestFilterCategories'].map(ApiFilterCategoryFromJSON)),
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'workflowType': !exists(json, 'workflowType') ? undefined : json['workflowType'],
        'workflowName': !exists(json, 'workflowName') ? undefined : json['workflowName'],
        'salesChannelCode': !exists(json, 'salesChannelCode') ? undefined : json['salesChannelCode'],
        'mainServiceCode': !exists(json, 'mainServiceCode') ? undefined : json['mainServiceCode'],
        'latitude': !exists(json, 'latitude') ? undefined : json['latitude'],
        'longitude': !exists(json, 'longitude') ? undefined : json['longitude'],
        'checkAvailability': !exists(json, 'checkAvailability') ? undefined : json['checkAvailability'],
    };
}
function ApiServiceSearchCriteriaToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
        'unitCodes': value.unitCodes,
        'startDate': (value.startDate),
        'endDate': (value.endDate),
        'numberOfAdults': value.numberOfAdults,
        'numberOfChildren': value.numberOfChildren,
        'numberOfInfants': value.numberOfInfants,
        'childAges': value.childAges,
        'productName': value.productName,
        'productId': value.productId,
        'destinationGeoUnitId': value.destinationGeoUnitId,
        'requestFilterCategories': value.requestFilterCategories === undefined ? undefined : (value.requestFilterCategories.map(ApiFilterCategoryToJSON)),
        'currency': value.currency,
        'workflowType': value.workflowType,
        'workflowName': value.workflowName,
        'salesChannelCode': value.salesChannelCode,
        'mainServiceCode': value.mainServiceCode,
        'latitude': value.latitude,
        'longitude': value.longitude,
        'checkAvailability': value.checkAvailability,
    };
}

export { ApiServiceSearchCriteriaFromJSON, ApiServiceSearchCriteriaFromJSONTyped, ApiServiceSearchCriteriaToJSON };
//# sourceMappingURL=ApiServiceSearchCriteria.js.map
